export default function TextAreaCell({
    value,
    minWidth,
}: {
    value: string;
    minWidth?: number | null;
}) {
    return (
        <div
            className={`${!navigator.userAgent.includes("Safari") ? "min-w-max" : "min-w-[250px]"} text-center`}
            style={{
                minWidth: minWidth || 0,
            }}
        >
            {value}
        </div>
    );
}
